// import React from "react";
// import {
//   AttachmentSection,
//   Button,
//   Divider,
//   FormFieldSet,
//   Modal,
//   NewTable,
//   PageHeader,
//   PageTitle,
//   useFormHandler,
// } from "../../../../../../../components";
// import { v4 as uuidv4 } from "uuid";
// import { dateFormator, mapTableRows } from "../../../../../../../utils";

// const AddPassport = ({ onClose, isOpen, isEdit, initialData }) => {
//   console.log("isEdit", isEdit);
//   const { formData, errors, handleChange, validateAllFields, setFormData } =
//     useFormHandler(
//       {
//         passportNumber: "",
//         status: "",
//         placeOfIssue: "",
//         placeOfBirth: "",
//         issuedDate: "",
//         expiryDate: "",
//         issuingCountry: "",
//         attachments: [
//           {
//             id: uuidv4(),
//             attachmentName: "",
//             attachmentComments: "",
//             chooseFiles: [],
//           },
//         ],
//       },
//       {
//         passportNumber: { type: "text", required: true },
//       }
//     );

//   const handleSave = () => {
//     const isValid = validateAllFields();
//     if (isValid) {
//       console.log("form data:", formData);
//       onClose();
//     } else {
//       console.log("error:", errors);
//     }
//   };

//   const getAttachmentError = (index, field) => {
//     return errors?.attachments?.[index]?.[field] || "";
//   };

//   const tableData = [
//     {
//       title: "Passport",
//       comments: "null",
//       attachment:
//         "1744408708_271323_2477483_6_8_0_0_0_Whatsapp-Image-20250411-at-17.07.35.jpeg ",
//     },
//   ];
//   const columns = [
//     {
//       key: "title",
//       label: "Title",
//     },
//     {
//       key: "comments",
//       label: "Comments",
//     },

//     {
//       key: "attachment",
//       label: "Attachment",
//       render: (row) => (
//         <div className="text-info cursor-pointer">
//           <Button
//             title={row.attachment}
//             variant="text"
//             color="info"
//             icon={"download"}
//             size="xs"
//             iconPosition="after"
//           />
//         </div>
//       ),
//     },

//     {
//       key: "actions",
//       label: "Actions",
//       render: (row) => (
//         <div className="flex gap-1">
//           <Button
//             type="icon"
//             icon="edit_square"
//             color="black"
//             variant="text"
//             size="xs"
//           />
//           <Button
//             type="icon"
//             icon="delete"
//             color="black"
//             variant="text"
//             size="xs"
//           />
//         </div>
//       ),
//     },
//   ];
//   const mappedRows = mapTableRows(tableData, columns);
//   return (
//     <Modal
//       title={isEdit ? "EDIT PASSPORT DETAILS" : "ADD PASSPORT DETAILS"}
//       onClose={onClose}
//       isOpen={isOpen}
//       width="max-w-7xl"
//     >
//       <div>
//         <div className="grid grid-cols-3 mt-4 gap-x-6 gap-y-4 ">
//           <FormFieldSet
//             type="text"
//             title={"Enter Passport Number"}
//             placeholder="Select Invoice Category"
//             value={formData.invoiceCategory}
//             onChange={(value) => handleChange("invoiceCategory", value)}
//             error={errors.invoiceCategory}
//           />
//           <FormFieldSet
//             type="select"
//             title={"Status"}
//             placeholder="Select Status"
//             value={formData.invoiceCategory}
//             onChange={(value) => handleChange("invoiceCategory", value)}
//             error={errors.invoiceCategory}
//           />
//           <FormFieldSet
//             type="text"
//             title={"Place of Issue"}
//             placeholder="Enter Place of Issue"
//             value={formData.invoiceCategory}
//             onChange={(value) => handleChange("invoiceCategory", value)}
//             error={errors.invoiceCategory}
//           />
//           <FormFieldSet
//             type="datepicker"
//             title={"Place of Birth"}
//             placeholder="Select Place of Birth"
//             value={formData.invoiceCategory}
//             onChange={(value) => handleChange("invoiceCategory", value)}
//             error={errors.invoiceCategory}
//           />
//           <FormFieldSet
//             type="datepicker"
//             title={"Issued Date"}
//             placeholder="Select Issued Date"
//             value={formData.invoiceCategory}
//             onChange={(value) => handleChange("invoiceCategory", value)}
//             error={errors.invoiceCategory}
//           />
//           <FormFieldSet
//             type="datepicker"
//             title={"Expiry Date"}
//             placeholder="Select Expiry Date"
//             value={formData.invoiceCategory}
//             onChange={(value) => handleChange("invoiceCategory", value)}
//             error={errors.invoiceCategory}
//           />
//           <FormFieldSet
//             type="select"
//             title={"Issuing Country"}
//             placeholder="Select Issuing Country"
//             value={formData.invoiceCategory}
//             onChange={(value) => handleChange("invoiceCategory", value)}
//             error={errors.invoiceCategory}
//           />
//         </div>
//         <div className="mt-6 ">
//           <PageHeader
//             Section={
//               <div className="flex">
//                 <PageTitle title={"ATTACHMENTS"} tag="p" />
//               </div>
//             }
//           />
//           <Divider />
//         </div>
//         <div>
//           <div className="max-w-7xl">
//             <AttachmentSection
//               attachments={formData.attachments}
//               onChange={(newAttachments) =>
//                 setFormData({ ...formData, attachments: newAttachments })
//               }
//               getAttachmentError={getAttachmentError}
//               showNameField={true}
//               showCommentsField={true}
//             />
//           </div>
//         </div>

//         {isEdit && (
//           <div className="mt-4">
//             <NewTable rows={mappedRows} columns={columns} hideToolBar />
//           </div>
//         )}

//         <div className="flex gap-3 justify-end my-8">
//           <Button title="Cancel" variant="outlined" onClick={onClose} />
//           <Button
//             title={isEdit ? "Update" : "Submit"}
//             onClick={() => handleSave()}
//           />
//         </div>
//       </div>
//     </Modal>
//   );
// };

// export default AddPassport;
import React from "react";
import {
  AttachmentSection,
  Button,
  Divider,
  FormFieldSet,
  Modal,
  TableAdv,
  PageHeader,
  PageTitle,
  useFormHandler,
} from "../../../../../../../components";
import { v4 as uuidv4 } from "uuid";
import { dateFormator, mapTableRows } from "../../../../../../../utils";
import { RecordStatus } from "../../../../../../../assets/data/enumData";

const AddPassport = ({ onClose, isOpen, isEdit, initialData }) => {
  console.log("isEdit", isEdit);
  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(
      {
        passportNumber: "",
        status: "",
        placeOfIssue: "",
        placeOfBirth: "",
        issuedDate: "",
        expiryDate: "",
        issuingCountry: "",
        choosedate: "",
        singleEmail: "",
        multipleEmails: [],
        attachments: [
          {
            id: uuidv4(),
            attachmentName: "",
            attachmentComments: "",
            chooseFiles: [],
          },
        ],
      },
      {
        passportNumber: { type: "text", required: true },
        choosedate: {
          type: "datepickerRange",
          required: true, // Set to true if you want it to be required
          customMessages: {
            required: "Please select both start and end dates",
            dateRange: "Start date must be before end date",
            invalidDate: "Please select valid dates",
          },
        },
        singleEmail: {
          type: "email",
          required: true,
          customMessages: {
            required: "Email address is required",
            invalid: "Please enter a valid email address",
          },
        },
        multipleEmails: {
          type: "email",
          required: true,
          multiple: true,
          // minSelection: 2,
          // maxSelection: 4,
          // customMessages: {
          //   required: "At least one email address is required",
          //   minSelection: "Please add at least 2 email address",
          //   maxSelection: "You can add up to 4 email addresses",
          //   invalidEmail: "Please enter valid email addresses",
          //   duplicateEmails: "Duplicate email addresses are not allowed",
          // },
        },
        attachments: [ { chooseFiles: { type: "file" } } ]
      }
    );

  const handleSave = () => {
    console.log("formData", formData);
    const isValid = validateAllFields();
    if (isValid) {
      console.log("form data:", formData);
      onClose();
    } else {
      console.log("error:", errors);
    }
  };

  const getAttachmentError = (index, field) => {
    return errors?.attachments?.[index]?.[field] || "";
  };

  const tableData = [
    {
      title: "Passport",
      comments: "null",
      attachment:
        "1744408708_271323_2477483_6_8_0_0_0_Whatsapp-Image-20250411-at-17.07.35.jpeg ",
    },
  ];
  const columns = [
    {
      key: "title",
      label: "Title",
    },
    {
      key: "comments",
      label: "Comments",
    },

    {
      key: "attachment",
      label: "Attachment",
      render: (row) => (
        <div className="text-info cursor-pointer">
          <Button
            title={row.attachment}
            variant="text"
            color="info"
            icon={"download"}
            size="xs"
            iconPosition="after"
          />
        </div>
      ),
    },

    {
      key: "actions",
      label: "Actions",
      render: (row) => (
        <div className="flex gap-1">
          <Button
            type="icon"
            icon="edit_square"
            color="black"
            variant="text"
            size="xs"
          />
          <Button
            type="icon"
            icon="delete"
            color="black"
            variant="text"
            size="xs"
          />
        </div>
      ),
    },
  ];
  const mappedRows = mapTableRows(tableData, columns);
  return (
    <Modal
      title={isEdit ? "EDIT PASSPORT DETAILS" : "ADD PASSPORT DETAILS"}
      onClose={onClose}
      isOpen={isOpen}
      width="max-w-7xl"
    >
      <div>
        <div className="grid grid-cols-2 xl:grid-cols-3 mt-4 gap-x-6 gap-y-4 ">
          <FormFieldSet
            type="text"
            title={"Enter Passport Number"}
            placeholder="Select Invoice Category"
            value={formData.passportNumber}
            onChange={(value) => handleChange("passportNumber", value)}
            error={errors.passportNumber}
          />
          <FormFieldSet
            type="select"
            title={"Status"}
            placeholder="Select Status"
            value={formData.status}
            onChange={(value) => handleChange("status", value)}
            error={errors.status}
            options={RecordStatus}
          />
          <FormFieldSet
            type="text"
            title={"Place of Issue"}
            placeholder="Enter Place of Issue"
            value={formData.placeOfIssue}
            onChange={(value) => handleChange("placeOfIssue", value)}
            error={errors.placeOfIssue}
          />
          <FormFieldSet
            type="datepicker"
            title={"Place of Birth"}
            placeholder="Select Place of Birth"
            value={formData.placeOfBirth}
            onChange={(value) => handleChange("placeOfBirth", value)}
            error={errors.placeOfBirth}
            showDropdown={false}
          />
          <FormFieldSet
            type="datepicker"
            title={"Issued Date"}
            placeholder="Select Issued Date"
            value={formData.issuedDate}
            onChange={(value) => handleChange("issuedDate", value)}
            error={errors.issuedDate}
            showDropdown={false}
          />
          <FormFieldSet
            type="datepicker"
            title={"Expiry Date"}
            placeholder="Select Expiry Date"
            value={formData.expiryDate}
            onChange={(value) => handleChange("expiryDate", value)}
            error={errors.expiryDate}
            showDropdown={false}
          />
          <FormFieldSet
            type="select"
            title={"Issuing Country"}
            showSearch
            placeholder="Select Issuing Country"
            value={formData.issuingCountry}
            onChange={(value) => handleChange("issuingCountry", value)}
            error={errors.issuingCountry}
          />
           {/* {checking the validation from emails and daterange} */}
          {/* <FormFieldSet
            type="datepickerRange"
            title="Choose Date"
            placeholder="Select From and To Date"
            value={formData.choosedate}
            onChange={(val) => handleChange("choosedate", val)}
            error={errors.choosedate}
          /> */}
         
          {/* <FormFieldSet
            // type="email"
            type="text"
            // title="singleEmail"
            title="Email validation check"
            placeholder="Enter singleEmail"
            value={formData.singleEmail}
            onChange={(val) => handleChange("singleEmail", val)}
            error={errors.singleEmail}
          />
          <FormFieldSet
            type="email"
            title="multipleEmails "
            placeholder="Add multipleEmails"
            value={formData.multipleEmails}
            onChange={(val) => handleChange("multipleEmails", val)}
            error={errors.multipleEmails}
            multiple
          /> */}
        </div>
        <div className="mt-6 ">
          <PageHeader
            Section={
              <div className="flex">
                <PageTitle title={"ATTACHMENTS"} tag="p" />
              </div>
            }
          />
          <Divider />
        </div>
        <div>
          <div className="max-w-7xl">
            <AttachmentSection
              attachments={formData.attachments}
              onChange={(newAttachments) =>
                setFormData({ ...formData, attachments: newAttachments })
              }
              getAttachmentError={getAttachmentError}
              showNameField={true}
              showCommentsField={true}
            />
          </div>
        </div>

        {isEdit && (
          <div className="mt-4">
            <TableAdv tableId={`immigration_h1b_h1bview_passporti94_passportdetail_addpassport`} rows={mappedRows} columns={columns} hideToolBar />
          </div>
        )}

        <div className="flex gap-3 justify-end my-8">
          <Button title="Cancel" variant="outlined" onClick={onClose} />
          <Button
            title={isEdit ? "Update" : "Submit"}
            onClick={() => handleSave()}
          />
        </div>
      </div>
    </Modal>
  );
};

export default AddPassport;
